module.exports = __webpack_public_path__ + "static/abass-6ebe9ca2d55ee5b018c05072de853ca8.png";